import React from "react";
import PropTypes from "prop-types";
import TextField from '@material-ui/core/TextField';
import Typography from "@material-ui/core/Typography";
import { makeStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';

const useStyles = makeStyles(theme => ({
  select:{
      fontSize: '0.75rem',
  },
  formControl: {
    minWidth: 120,
    maxWidth: 300,
    margin: '0px',
    marginTop: '16px'
  },
  typography: {
    color: 'rgba(0, 0, 0, 0.54)',
    padding: 0,
    fontSize: '1rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: 'translate(0, 1.5px) scale(0.75)',
    transformOrigin: 'top left',
    letterSpacing: '0.00938em',
    transition: 'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
  }
}));

const Warranty = ({
  onChange,
  disabled,
  error,
  title,
  warranty,
  warranty_states,
  ...props
}) => {

  const handleChange = event => {
    onChange(event, 'warranty')
  }

  const classes = useStyles();


  return (
    <React.Fragment>
      <Typography variant="h6" className="mt-2">
        {title}
      </Typography>

      <TextField
        id="warranty_up_to_km"
        name="warranty_up_to_km"
        label="KM límite"
        disabled={disabled}
        type="text"
        placeholder="Ingrese el kilometraje limite de la garantía"
        onChange={handleChange}
        value={warranty.warranty_up_to_km}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
      />

      <TextField
        id="warranty_up_to_date"
        name="warranty_up_to_date"
        label="Fecha vto. garantía"
        disabled={disabled}
        type="date"
        placeholder="Ingrese la fecha fin de garantía"
        onChange={handleChange}
        value={warranty.warranty_up_to_date}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
      />

      <FormControl className="mt-3 mr-2" style={{minWidth: 200, fontSize: '0.75rem'}} name='warranty_state' >
        <InputLabel htmlFor="grouped-native-select" autoWidth="true" style={{minWidth: 150, fontSize: '0.75rem'}} >Seleccione el estado de la garantía</InputLabel>
        <Select native name='warranty_state'
            inputProps={{
              name:"warranty_state",
              className:"warranty_state"
            }}
            style={{minWidth: 200, fontSize: '0.75rem'}}
            disabled={disabled}
            onChange={handleChange}
            error={(error !=='' && warranty.warranty_state ==='') ? 'Debe completar este campo' :  false }
            value={warranty.warranty_state}
            input={<Input id="grouped-native-select" name='warranty_state'/>}>
            <option value="" />
            {warranty_states.map((warranty_state) => <option id={warranty_state.id} value={warranty_state.id}>{warranty_state.name}
          </option>)}
        </Select>
      </FormControl>


	</React.Fragment>
	)

}
export default Warranty;
